const IMPORT_REJECTION_MESSAGE_BASE_KEY = 'pages.import.historyPage.diagnosticsModal.rejectionReasons'

const EXACT_MESSAGE_KEYS: Readonly<Record<string, string>> = {
  'Invalid phone number': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.invalidPhoneNumber`,
  'Birthdate format is not supported': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.birthdateFormatNotSupported`,
  'Store value could not be mapped': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.storeValueCouldNotBeMapped`,
  'Store ignored': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.storeIgnored`,
  'Unknown error': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.missingContactIdentifier`,
  'The string supplied did not seem to be a phone number.': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.notAPhoneNumber`,
  'The string supplied is too short to be a phone number.': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.phoneNumberTooShort`,
  'The string supplied is too long to be a phone number.': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.phoneNumberTooLong`,
  'Could not interpret numbers after plus-sign.': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.couldNotInterpretNumbersAfterPlus`,
  'Invalid country calling code': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.invalidCountryCallingCode`,
  'Phone number is not a valid mobile phone number': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.notAValidMobilePhoneNumber`,
  'No phone or email provided': `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.noPhoneOrEmailProvided`
}

const MESSAGE_PATTERNS: ReadonlyArray<{
  pattern: RegExp
  key: string
  params?: (match: RegExpMatchArray) => Record<string, string>
}> = [
  {
    pattern: /^Could not parse mobile phone number: (.+)$/,
    key: `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.couldNotParseMobilePhoneNumber`,
    params: (match) => ({ phone: match[1] })
  },
  {
    pattern: /^SQLSTATE\[23000]: Integrity constraint violation: 1062 Duplicate entry/,
    key: `${IMPORT_REJECTION_MESSAGE_BASE_KEY}.duplicateEntry`
  }
]

type TranslateFn = (key: string, params?: Record<string, unknown>) => string

type TranslationExistsFn = (key: string) => boolean

export function translateImportRejectionMessage(message: string, t: TranslateFn, te: TranslationExistsFn): string {
  const exactKey = EXACT_MESSAGE_KEYS[message]

  if (exactKey !== undefined && te(exactKey)) {
    return t(exactKey)
  }

  for (const { pattern, key, params } of MESSAGE_PATTERNS) {
    const match = message.match(pattern)

    if (match !== null && te(key)) {
      return t(key, params?.(match) ?? {})
    }
  }

  return message
}
